import styled from "styled-components/macro";

export const Root = styled.div`
  box-sizing: border-box;
  padding: 60px 0 250px;
  margin: 0 auto;
  max-width: 1400px;
  width: 75%;

  @media (max-width: 1024px) {
    padding: 40px 111px;
  }

  @media (max-width: 577px) {
    padding: 30px 20px;
    width: 100%;
  }
`;

export const TitlePage = styled.div`
  font-size: 32px;
  font-weight: 400;
  font-family: Palatino Linotype;
  color: rgba(0, 0, 0, 0.8);
  opacity: 0.8;

  @media (max-width: 1024px) {
    padding-bottom: 5px;
    font-size: 30px;
  }

  @media (max-width: 577px) {
    padding-bottom: 5px;
    font-size: 25px;
  }
`;
